import { sentenceCase } from 'change-case';
import { filter } from 'lodash';
import { useRef, useState } from 'react';
// @mui
import {
    Avatar,
    Checkbox,
    IconButton,
    MenuItem,
    Paper,
    Popover,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TablePagination,
    TableRow,
    Typography,
} from '@mui/material';
import Iconify from '../iconify';
import Label from '../label';
import EmtyData from '../emty-data';
import { FormatNumber, session } from 'src/utils';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
}
const USERLIST = [];
export default function TableBodyComponent({ cols = [], data = [], isNotFound }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(null);

    const [page, setPage] = useState(0);

    const [order, setOrder] = useState('asc');

    const [selected, setSelected] = useState([]);

    const [orderBy, setOrderBy] = useState('name');

    const [filterName, setFilterName] = useState('');

    const [rowsPerPage, setRowsPerPage] = useState(5);
    const tableRef = useRef(null);

    const handleOpenMenu = (event) => {
        setOpen(event.currentTarget);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = USERLIST.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

    const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

    const handleCloseMenu = () => {
        setOpen(null);
    };
    const renderColumn = (row, col, index) => {
        if (col.type === 'index') return <TableCell>{index + 1}</TableCell>;
        if (col.type === 'number')
            return (
                <TableCell sx={{ textAlign: col.position || 'right' }}>{FormatNumber(+row[col.field] || 0)}</TableCell>
            );
        // if (col.type === 'money') {
        //     const lang = localStorage.getItem(session.LOCAL_LANGUAGE) || 'vi';
        //     let symbol = '';
        //     if (lang === 'jp') symbol = '¥';
        //     else if (lang === 'jp') symbol = '$';
        //     else symbol = '₫';
        //     return (
        //         <TableCell sx={{ textAlign: col.position || 'right' }}>
        //             {FormatNumber(+row[col.field] || 0)}
        //             {t('symbolMoney')}
        //         </TableCell>
        //     );
        // }
        if (col.type === 'money') {
            const [amount = "0", symbol = ""] = String(row[col.field] || "").split(" ");
            return (
                <TableCell sx={{ textAlign: col.position || 'right' }}>
                    {FormatNumber(+amount || 0)}
                    {symbol}
                </TableCell>
            );
        }
        if (col.type === 'unit') {
            let unit = t('unitPcs');
            return (
                <TableCell sx={{ textAlign: col.position || 'right' }}>
                    {FormatNumber(+row[col.field] || 0)}
                    {row[col.unit] || unit}
                </TableCell>
            );
        }
        if (col.type === 'status') {
            let unit = t('borrowed');
            if (row[col.field] === 'ebr') {
                unit = t('borrowed');
            } else {
                unit = t('bad_report');
            }
            return <TableCell sx={{ textAlign: col.position || 'right' }}>{row[col.unit] || unit}</TableCell>;
        }
        if (col.type === 'have_delete') {
            return <TableCell sx={{ textAlign: 'left' }}>{row[col.field]} <span style={{fontSize: 12, color: "gray"}}>{row['work_status'] === "0" && ("(" + t('have_deleted') + ")") }</span></TableCell>;
        }

        return <TableCell>{row[col.field]}</TableCell>;
    };
    return (
        <>
            <TableBody sx={{ overflow: 'scroll' }}>
                {data?.length > 0 ? (
                    data.map((row, index) => (
                        <TableRow hover tabIndex={-1} role="checkbox" selected={false}>
                            <TableCell></TableCell>
                            {cols?.length > 0 && cols.map((col) => renderColumn(row, col, index))}
                        </TableRow>
                    ))
                ) : (
                    <TableRow hover tabIndex={-1} role="checkbox" selected={false}>
                        <TableCell colSpan={cols.length + 1}>
                            <EmtyData />
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>

            {isNotFound && (
                <TableBody>
                    <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <Paper
                                sx={{
                                    textAlign: 'center',
                                }}
                            >
                                <Typography variant="h6" paragraph>
                                    Not found
                                </Typography>

                                <Typography variant="body2">
                                    No results found for &nbsp;
                                    <strong>&quot;{filterName}&quot;</strong>.
                                    <br /> Try checking for typos or using complete words.
                                </Typography>
                            </Paper>
                        </TableCell>
                    </TableRow>
                </TableBody>
            )}

            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleCloseMenu}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        p: 1,
                        width: 140,
                        '& .MuiMenuItem-root': {
                            px: 1,
                            typography: 'body2',
                            borderRadius: 0.75,
                        },
                    },
                }}
            >
                <MenuItem>
                    <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
                    Edit
                </MenuItem>

                <MenuItem sx={{ color: 'error.main' }}>
                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                    Delete
                </MenuItem>
            </Popover>
            {/* <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                component="div"
                count={100}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
        </>
    );
}
